var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field--submit"},[_c('div',{staticClass:"field__element-wrap"},[_c('theme-btn',_vm._g({ref:"fieldElement",attrs:{"name":_vm.name,"type":"submit","disabled":_vm.disabled,"parts":_vm.parts}},_vm.$listeners),[_vm._t("default")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f78f8d3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/SubmitField.vue
// module id = null
// module chunks = 